import React from 'react';
import { BodySmallRegular, H6Emphasized, YStack } from 'smoothie';

export interface MoneyMapperSectionHeadingProps {
    title: string;
    subtitle?: string;
    /** Extra space below the subtitle (e.g. 12 before the next block). */
    subtitleMarginBottom?: number;
}

export const MoneyMapperSectionHeading = ({
    title,
    subtitle,
    subtitleMarginBottom,
}: MoneyMapperSectionHeadingProps) => (
    <YStack gap={6}>
        <H6Emphasized color="$gray1200">{title}</H6Emphasized>
        {subtitle != null && subtitle !== '' ? (
            <BodySmallRegular
                color="$gray1000"
                {...(subtitleMarginBottom != null
                    ? { marginBottom: subtitleMarginBottom }
                    : {})}
            >
                {subtitle}
            </BodySmallRegular>
        ) : null}
    </YStack>
);
